export default "__VITE_ASSET__DnbAUUVu__"